import { supabase } from '@/lib/supabase'

export async function fetchSignalsClosedReasonsForOpportunities(
  opportunityIds: number[],
): Promise<Record<string, string | null>> {
  const map: Record<string, string | null> = {}
  const ids = Array.from(new Set(opportunityIds.filter((id) => Number.isFinite(id))))
  if (ids.length === 0) return map

  const { data, error } = await supabase
    .from('trading_opportunities')
    .select('id,closed_reason')
    .in('id', ids)

  if (error) {
    console.error('fetchSignalsClosedReasonsForOpportunities error', error)
    return map
  }

  const rows = Array.isArray(data) ? data : []
  for (const row of rows as any[]) {
    if (!row) continue
    const key = String((row as any).id)
    map[key] = (row as any).closed_reason ?? null
  }

  return map
}

